import { Button, Checkbox, Col, DatePicker, Icon, Input, Modal, Radio, Row, Select, Spin, message, notification } from 'antd'
import React, { Fragment, useEffect, useState, useRef } from 'react'
import { SOMETHING_WENT_WRONG, SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN, SUB_TYPE_OF_CALL, get_label_from_value, type_of_call_format } from '../../../utils/Constants'
import { Translate } from 'react-translated'
import F from "../../../Functions";
import moment from 'moment'
import axios from 'axios';
import Cookies from 'js-cookie';
import * as _ from 'lodash';
import { REQUEST_CALL } from '../../../utils/Api_enums';
import { useBoundStore } from '../../../store/useBoundStore';

const Option = Select.Option
const { TextArea } = Input;
const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

const SentFollowupModal = React.memo(function SentFollowupModal(props) {
  const currentMonth = moment().month();
  const currentYear = moment().year();
  const currentDate = moment().date();
  const months = moment.months();
  const [loading, setloading] = useState(false)
  const [user, setUser] = useState({})
  const [places, setplaces] = useState([]);
  const getInitialMonth = () => {
    return currentDate >= 15 ? (currentMonth + 1) % 12 : currentMonth;
  };
  const agencyIdRef = useRef(null);

  const [selectedMonth, setSelectedMonth] = useState(getInitialMonth());
  const [data, setData] = useState({
    first_name: "",
    last_name: "",
    phone: "",
    dob_mm: "",
    dob_yyyy: "",
    fs_effective_date: moment(new Date()).add(15, "days"),
    rs_effective_date: moment(new Date()).add(15, "days"),
    rs_review_month: moment().date() >= 15
      ? moment().add(1, 'months').format("MM")
      : moment().format("MM"),
    followup_month: moment().date() >= 15
      ? moment().add(1, 'months').format("MM")
      : moment().format("MM"),
    type_of_call: '',
    sub_type_of_call: "",
    address: "",
    address_cont: "",
    city: "",
    state: "",
    zipcode: "",
    note: "",
    agency_id: null,
    rs_action: null,
    type_of_call_visible: {
      vonboard: 0,
      review: 0,
      is_lead: 0,
      is_opportunity: 0
    }
  })
  const [wizard, setWizard] = useState(
    {
      "acknowledge_by": null,
      "address": "",
      "address_cont": "",
      "business_name": "",
      "business_name_spouse": "",
      "business_owner_toggle": "",
      "business_owner_spouse_toggle": "",
      "business_type_spouse": "",
      "business_type_other_spouse": "",
      "business_type": "",
      "business_type_other": "",
      "employed_toggle": "",
      "employed_toggle_spouse": "",
      "employer_name": "",
      "employer_name_spouse": "",
      "employer_years": "",
      "employer_years_spouse": "",
      "employed_anual_income": "",
      "employed_anual_income_spouse": "",
      "city": "",
      "email": "",
      "employed_retired_disabled": "",
      "employed_retired_disabled_spouse": "",
      "employer_retire_from": "",
      "employer_retire_from_spouse": "",
      "home_market_value": "",
      "home_mortgage": "",
      "home_mortgage_protection_toggle": "",
      "home_mortgage_protection_benefit": "",
      "home_mortgage_toggle": "0",
      "home_mortgage_protection_policy": "[]",
      "home_toggle": "",
      "insurance_score": "",
      "spouse_last_name": "",
      "retirement_plan": "",
      "retirement_plan_value": "",
      "retirement_plan_spouse": "",
      "retirement_plan_value_spouse": "",
      "secondary_home_market_value": "",
      "secondary_home_mortgage": "",
      "secondary_mortgage_protection_benefit": "",
      "secondary_mortgage_protection_policy": "",
      "secondary_mortgage_protection_toggle": "",
      "secondary_home_mortgage_toggle": "",
      "secondary_home_toggle": "",
      "secondary_home_type": "[]",
      "personal_property_toggle": null,
      "personal_property_value": "",
      "primary_vehicles_toggle": "",
      "primary_vehicles_num": null,
      "secondary_vehicles_toggle": "",
      "secondary_vehicles_value": "",
      "secondary_vehicles": "[]",
      "spouse_first_name": "",
      "spouse_toggle": null,
      "asset_total_value": "",
      "asset_total_value_spouse": "",
      "zipcode": "",
      "state": "",
      "asset_preservation_toggle": "",
      "asset_preservation_value": "",
      "asset_preservation_value_spouse": "",
      "life_opportunities": 1,
      "no_policies_sold": 0,
      "policy_umbrella_total": 0,
      "rollover_opportunities": 0,
      "status": "New B File",
      "quote_auto_toggle": "",
      "auto_sold_toggle": "",
      "quote_home_toggle": "",
      "employees_count": null,
      "employees_count_spouse": null,
      "home_sold_toggle": "",
      "cross_sell_policies_uncovered": 0,
      "cross_sell_opportunities_quoted": 0,
      "cross_sell_opportunities_sold": 0,
      "umbrella_policy_quoted": 0,
      "umbrella_policy_sold": 0,
      "umbrella_policy_uncovered": 0,
      "umbrella_limit": "",
      "attempts": "0",
      "action": "",
      "call_type": "",
      "vip": 0,
      "children": null,
      "need_attention": 0,
      // "birthday": "05/01/2014",
      "spouse_birthday": "",
      "phone2": "",
      "auto_policy_sold_current_liability_limit": "",
      "auto_policy_sold_bfile_limit": "",
      "auto_policy_sold_liability_limit_sold": "",
      "auto_policy_sold_items_sold": "",
      "auto_policy_sold_policy_premium": "",
      "auto_policy_sold_term": "",
      "auto_policy_not_sold_current_carrier": "",
      "auto_policy_not_sold_current_liability_limit": "",
      "auto_policy_not_sold_expiration_date": null,
      "home_policy_sold_liability_limit": "",
      "home_policy_sold_bfile_limit": "",
      "home_policy_sold_liability_limit_sold": "",
      "home_policy_sold_items_sold": "",
      "home_policy_sold_policy_premium": "",
      "home_policy_sold_term": "",
      "home_policy_not_sold_current_carrier": "",
      "home_policy_not_sold_current_liability_limit": "",
      "home_policy_not_sold_expiration_date": null,
      "auto_policy_sold_effective_date": null,
      "home_policy_sold_effective_date": null,
      "is_lead": 0,
      "is_saved_for_later": 0,
      "is_requote": 0,
      "is_renewal": 0,
      "is_onboarded": 1,
      "nosalearchive_expiration_date": null,
      "facebook": "",
      "twitter": "",
      "linkedin": "",
      "profile_photo": "",
      "archive": 0,
      // "expiration_date": "2024-03-15",
      "parent_id": null,
      "vonboard": 1,
      // "is_lead" : 1,
      // "is_opportunity" : 1,
      "financial_id": null,
      "onboarding_id": null,
      "onboarding_user": null,
      "vob_archived": null,
      "asset_401k_accounts": "[]",
      "asset_401k_accounts_spouse": "[]",
      "asset_accounts": "[]",
      "asset_accounts_spouse": "[]",
      "personal_property_type": "[]",
      "policies": [],
      "liability_calculator_value": "0",
      "mortgage_review": null,
      "mortgage_purchase_home": null,
      "had_mortgage_review": null,
      "no_follow_up": null,
      "asset_401k_accounts_toggle": null,
      "asset_401k_accounts_toggle_spouse": null,
      "asset_401k_value": 0,
      "zillow_address": null,
      "zillow_estimated_value": null,
      "secondary_zillow_address": null,
      "secondary_zillow_estimated_value": null,
      "review": 0
    }
  )


  const isMonthDisabled = (monthIndex) => {
    const isCurrent = monthIndex === currentMonth;
    const isPast = monthIndex < currentMonth;
    return (isCurrent && currentDate >= 15) || (isPast && !isCurrent);
  };




  const [type_of_call_old, settype_of_call_old] = useState(props.bfile.type_of_call || "")
  useEffect(() => {
    setloading(false)
    setUser(props.bfile.user || {})

    if (props.bfile.user && props.bfile.user.id) {
      userLoad(props.bfile.user.id)
    }

    let temp_type_of_call = props.bfile.type_of_call;
    let review = 1;
    let vonboard = 1;
    let is_opportunity = 1;
    let is_lead = 1;

    if (props.requestButtonVisiblelanding) {
      review = props.requestButtonVisiblelanding.review;
      vonboard = props.requestButtonVisiblelanding.vonboard;
      is_lead = props.requestButtonVisiblelanding.is_lead;
      is_opportunity = props.requestButtonVisiblelanding.is_opportunity;
    } else if (props.requestButtonVisible) {
      review = props.requestButtonVisible.review;
      vonboard = props.requestButtonVisible.vonboard;
      is_lead = props.requestButtonVisible.is_lead;
      is_opportunity = props.requestButtonVisible.is_opportunity;
    }

    if (props.bfile.agency && props.bfile.type_of_call && review == 0 && props.bfile.type_of_call === 'Review') {
      temp_type_of_call = ''
    }

    if (props.bfile.agency && props.bfile.type_of_call && vonboard == 0 &&
      ['Prospect', 'FollowUp', 'Follow-Up', 'Followup', 'Follow-up'].includes(props.bfile.type_of_call)) {
      temp_type_of_call = ''
    }

    setData(prev => ({
      ...prev,
      type_of_call: temp_type_of_call || '',
      sub_type_of_call:
        get_label_from_value(props.bfile.sub_type_of_call, 'value', props.bfile.type_of_call) &&
          props.bfile.type_of_call
          ? Array.from(new Set(
            (type_of_call_format(props.bfile.type_of_call) === 'followup'
              ? "Thank You / Referrals," +
              get_label_from_value(props.bfile.sub_type_of_call, 'value', props.bfile.type_of_call)
              : get_label_from_value(props.bfile.sub_type_of_call, 'value', props.bfile.type_of_call) || ""
            ).split(",")
          )).join(",")
          : type_of_call_format(props.bfile.type_of_call) === 'followup'
            ? 'Thank You / Referrals'
            : "",
      rs_effective_date: moment(new Date()).add(15, "days"),
      fs_effective_date:
        props.bfile &&
          props.bfile.bfile_sub &&
          props.bfile.bfile_sub[0] &&
          props.bfile.bfile_sub[0].fs_effective_date
          ? moment(props.bfile.bfile_sub[0].fs_effective_date)
          : moment(new Date()).add(15, "days"),
      rs_review_month:
        moment().date() >= 15
          ? moment().add(1, 'months').format("MM")
          : moment().format("MM"),
      followup_month:
        moment().date() >= 15
          ? moment().add(1, 'months').format("MM")
          : moment().format("MM"),
      phone: props.bfile.phone
        ? F.phone_format(props.bfile.phone.trim().replace(/[^0-9]/g, ''))
        : "",
      first_name: props.bfile.first_name || "",
      last_name: props.bfile.last_name || "",
      dob_mm:
        props.bfile.birthday
          ? props.bfile.birthday.split("/")[0] +
          " - " +
          monthNames[parseInt(props.bfile.birthday.split("/")[0]) - 1]
          : "",
      dob_yyyy: props.bfile.birthday
        ? props.bfile.birthday.split("/")[2]
        : "",
      rs_action: props.bfile.rs_action || null,
      address: props.bfile.address || null,
      address_cont: props.bfile.address_cont || null,
      city: props.bfile.city || null,
      state: props.bfile.state || null,
      zipcode: props.bfile.zipcode || null,
      questions: props.bfile.questions || [],
      type_of_call_visible: { review, vonboard, is_lead, is_opportunity }
    }));

    setWizard(prev => ({
      ...prev,
      id: props.bfile.id,
      vob_archived: props.bfile.vob_archived
    }));

  }, [
    props.bfile.id,
    props.bfile.type_of_call,
    props.bfile.sub_type_of_call,
    props.bfile.phone,
    props.bfile.first_name,
    props.bfile.last_name,
    props.bfile.birthday,
    props.bfile.address,
    props.bfile.address_cont,
    props.bfile.city,
    props.bfile.state,
    props.bfile.zipcode,
    props.bfile.questions,
    props.bfile.bfile_sub,
    props.bfile.vob_archived,
    props.bfile && props.bfile.user && props.bfile.user.id,
    props.bfile.agency,
    props.requestButtonVisiblelanding,
    props.requestButtonVisible
  ]);


  const fetchAddress = async (val) => {
    if (val.length > 2) {
      try {
        const resp = await axios.get(`/api/google_maps/google_search_maps?query=${val}`);
        if (resp.data.success === true)
          setplaces(resp.data.response_json.results)
      } catch (error) {
        F.showAndHandleServerError(error);
        // console.error("Error fetching address:", error);
      }
    } else {
      setplaces([])
    }
  };


  const handleMonthChange = (selectedMonthIndex) => {
    setSelectedMonth(selectedMonthIndex);
    const startDate = moment().month(selectedMonthIndex).startOf('month');
    const endDate = moment().month(selectedMonthIndex).endOf('month');
    data.rs_review_month = moment().month(selectedMonthIndex).format("MM");
    data.followup_month = moment().month(selectedMonthIndex).format("MM");
    console.log(data.rs_review_month);
    console.log(data.followup_month);
  }

  const handleAutoFill = async (placeId) => {
    try {
      const resp = await axios.get(`/api/google_maps/google_fetch_place_by_place_id?place_id=${placeId}`);

      if (resp.data.success === true) {
        setData({
          ...data,
          "address": resp.data.street || "",
          // "address_cont": resp.data.street2 || "NA",
          "city": resp.data.city || "NA",
          "state": resp.data.state || "NA",
          "zipcode": resp.data.zip_code || "NA",
        })
        setplaces([]);
      }
    } catch (error) {
      F.showAndHandleServerError(error);
    }
  }

  const renderDropDown = (location = []) => {
    return (
      <div style={{
        position: 'absolute',
        top: '80%',
        left: '3%',
        width: '95%',
        border: '1px solid #ccc',
        borderRadius: '4px',
        backgroundColor: '#fff',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
        zIndex: 10,
      }}
      >
        <div style={{
          padding: "5px 10px",
          display: "flex",
          justifyContent: "space-between",
        }}>
          Address Suggestion
          <Button onClick={() => { setplaces([]) }}>
            <Icon type="close" />
          </Button>
        </div>
        <div style={{
          overflow: "auto",
          maxHeight: 500
        }}>
          {location.map((suggestion, index) => (
            <div
              key={index}
              style={{
                padding: '10px',
                cursor: 'pointer',
                borderBottom: '1px solid #eee',
                display: 'flex',
                alignItems: 'center',
              }}
              onClick={() => handleAutoFill(suggestion.place_id)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  handleAutoFill(suggestion.place_id);
                }
              }}
              tabIndex={0}
              aria-label='Select'
            >
              <img
                src="https://maps.gstatic.com/mapfiles/place_api/icons/v1/png_71/geocode-71.png"
                alt="icon"
                style={{ width: '20px', marginRight: '10px' }}
              />
              <div>
                <strong>{suggestion.name}</strong>
                <p style={{ margin: 0, fontSize: '12px', color: '#555' }}>
                  {suggestion.formatted_address}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  }

  const debouncedFetchAddress = _.debounce(fetchAddress, 300);

  const handleAddressChange = (e) => {
    setData({ ...data, address: e.target.value, addressChanged: true });
    debouncedFetchAddress(e.target.value);
  }

  const userLoad = (id) => {
    let userById = useBoundStore.getState().userById;
    if (!userById) {
      setloading(true)
      axios.get("/api/users/" + id).then(res => {
        if (!data.agency_id && res.data.user_agency_assoc && res.data.user_agency_assoc[0] && res.data.user_agency_assoc[0].agency_id) {
          setData({ ...data, agency_id: res.data.user_agency_assoc[0].agency_id });
          agencyIdRef.current = res.data.user_agency_assoc[0].agency_id;
          useBoundStore.getState().setUserById(res.data)
        }

        {
          props.showModal && axios.get("/api/get_agency_owner_details").then(({ data: { error_response, agency_owner_details, success } }) => {
            if (success && !error_response) {
              setUser({ ...res.data, carrier: agency_owner_details.carrier });
            } else {
              message.error(error_response)
            }
          })
        }

      }).finally(() => setloading(false))
    } else {
      setloading(true)
      if (!data.agency_id && userById.user_agency_assoc && userById.user_agency_assoc[0] && userById.user_agency_assoc[0].agency_id) {
        setData({ ...data, agency_id: userById.user_agency_assoc[0].agency_id });
        agencyIdRef.current = userById.user_agency_assoc[0].agency_id;
      }

      {
        props.showModal && axios.get("/api/get_agency_owner_details").then(({ data: { error_response, agency_owner_details, success } }) => {
          if (success && !error_response) {
            setUser({ ...userById, carrier: agency_owner_details.carrier });
          } else {
            message.error(error_response)
          }
        }).finally(() => {
          setloading(false);
        })
      }

    }
  }


  const SendFollowUp = () => {

    let error = null;
    let dateTime = moment().utc().format("YYYY-MM-DD HH:mm:ss")


    let conditional_data = {}
    // TODO:
    if (['followup', 'prospect'].includes(data.type_of_call.split('-').join().toLowerCase())) {
      conditional_data = {
        review: 0,
        vonboard: 1,
        is_renewal: 0,
        is_onboarded: 1,
        reviewer_id: null,
        onboarder_id: props.user.id,
        status: "New B File",
        vob_completed: null,
        onboarding_user: null,
        vo_sent_date: dateTime,
        vob_attempted: null,
        vob_archived: null,
        vo_claim_date: null,
        von_appointment_date: null,
        bfile_review_completed: 0,
        bfile_folow_up_completed: null,
        fs_consecutive: 0,
        rs_consecutive: 0,
      }
    } else {
      conditional_data = {
        fs_consecutive: 0,
        rs_consecutive: 0,
        review: 1,
        vonboard: 0,
        rs_action: null,
        rs_attempts: null,
        is_renewal: 1,
        is_onboarded: 0,
        reviewer_id: props.user.id,
        onboarder_id: null,
        status: "Renewal",
        vo_sent_date: null,
        rs_archived: null,
        bfile_review_completed: 0,
        bfile_folow_up_completed: null,
        rs_appointment_date: null,
        rs_date: moment(new Date())
          .utc()
          .format("YYYY-MM-DD HH:mm:ss"),
      }
    }

    let temp = {
      first_name: F.stripHtml(data.first_name),
      last_name: F.stripHtml(data.last_name),
      address: data.address,
      address_cont: data.address_cont,
      city: data.city,
      state: data.state,
      zipcode: data.zipcode,
      phone: F.removeFormatterFromPhoneNumber(data.phone),
      questions: data.questions || [],
      type_of_call: data.type_of_call,
      sub_type_of_call: data.sub_type_of_call,
      birthday: data.dob_mm && data.dob_mm.split("-")[0].trim() + "/01/" + data.dob_yyyy,
      // rs_effective_date: data.rs_effective_date.format("YYYY-MM-DD"),
      // expiration_date: moment(data.rs_effective_date).add(30, "days").format('YYYY-MM-DD'),
      is_saved_for_later: 0,
      archive: 0,
      non_responsive: 0,
      user_id: props.user.id || "",
      bad_phone_number_status: 0,
      ...(data.rs_action === 2 ? { rs_action: null } : {}),
      ...(wizard.vob_archived === 1 ? { vob_archived: null, onboarding_user: null, onboarding_id: null } : {}),
      ...(data.type_of_call === 'Review'
        ? { bfile_sub: { rs_review_month: data.rs_review_month } }
        : { bfile_sub: { followup_month: data.followup_month } }
        // : { bfile_sub: { fs_effective_date: moment(data.fs_effective_date).format('YYYY-MM-DD') } }
      ),
      ...conditional_data

    }

    // console.log(JSON.stringify(temp));


    if (!data.type_of_call && !error) {
      error = 'Please select a type of call to proceed.'
    }
    if (!data.sub_type_of_call && !error) {
      error = 'Please select a sub type of call to proceed.'
    }
    if ((!data.phone || data.phone.length !== 14 || !F.validatePhoneRegix(data.phone)) && !error) {
      error = 'Please enter a correct phone number to proceed.'
    }
    if (!data.first_name.trim() && !error) {
      error = 'Please enter a first name to proceed.'
    }
    if (!data.last_name.trim() && !error) {
      error = 'Please enter a last name to proceed.'
    }
    if ((!data.dob_mm || !data.dob_yyyy) && user.carrier !== "Country Financial" && !error) {
      error = 'Please select a dob to proceed.'
    }
    if (!data.note.trim() && !error) {
      error = 'Please fill a note to proceed.'
    }



    if (!error) {
      setloading(true);

      let ajax = null;

      temp["bfile_notes"] = {
        note: "Request Call has been created for" + " " + F.stripHtml(data.note) + " ; " + data.sub_type_of_call
      };

      delete temp["onboarding_user"];

      if (wizard.id) {
        //PUT REQUEST
        if (data.addressChanged) {
          temp["customer_timezone"] = null;
          temp["customer_distance"] = null;
        }

        temp = F.nullifyCallAttemptsQuestionArray(temp);
        ajax = axios.put(`${REQUEST_CALL}/${wizard.id}`, {
          ...temp,
          agency_id: data.agency_id || agencyIdRef.current
        });
      } else {
        // POST REQUEST
        delete wizard["id"];
        delete wizard["onboarding_user"];

        ajax = axios.post(REQUEST_CALL, {
          ...wizard,
          ...temp,
          agency_id: data.agency_id || agencyIdRef.current
        });
      }

      ajax
        .then(res => {
          setloading(false);
          const bfile = res.data;

          if (bfile.id && bfile.success) {
            setData({});
            props.hideModal();
            message.success(bfile.message);
            // message.success("Request Call has been created");
            setSelectedMonth(currentMonth);

            if (window.location.hash.includes("/dashboard")) {
              window.location.reload();
            } else {
              props.history.push({
                pathname: props.user.id === 2 ? "/bfiles" : "/dashboard",
                state: { ...props.history.location.state }
              });
            }
          } else if (!bfile.success) {
            message.error(
              F.getErrorMessage(res)
            );
          }
        })
        .catch(err => {
          setloading(false);


          const apiError = err && err.response && err.response.data;
          const errorMsg =
            apiError &&
            apiError.error_response || apiError && apiError.message ||
            SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN;
          message.error(errorMsg);
        });

    } else {
      error && message.error(error);
    }

  }


  const resetSetForm = () => {
    setData({
      ...data,
      first_name: "",
      last_name: "",
      phone: "",
      dob_mm: "",
      dob_yyyy: "",
      note: ""
    })
  }


  const onChangeData = (e) => {
    if (e && e.target && e.target.name == "type_of_call" && e.target.value == "Review") {
      setSelectedMonth(getInitialMonth())
      const startDate = moment().month(selectedMonth).startOf('month');
      data.rs_effective_date = startDate;
    } else if (e && e.target && e.target.name == "fs_effective_date" && e.target.value) {
      data.fs_effective_date = e.target.value.format("YYYY-MM-DD");
    }

    e = { ...e };
    let value = Array.isArray(e.target.value) ? e.target.value.join() : e.target.value
    if (e && e.target && e.target.name !== null && e.target.value !== null) {



      if (e.target.name === 'type_of_call' && e.target.value === 'FollowUp') {
        setData({ ...data, [e.target.name]: value, sub_type_of_call: 'Thank You / Referrals' });
      }
      else if (e.target.name === 'type_of_call' && e.target.value !== 'FollowUp') {
        setData({ ...data, [e.target.name]: value, sub_type_of_call: "" });
      }
      else {
        setData({ ...data, [e.target.name]: value });
      }

      if (e.target.value && e.target.name === 'phone' && e.target.value.length === 14 && F.validatePhoneRegix(e.target.value)) {
        const phoneNumberFormatterRemoved = F.removeFormatterFromPhoneNumber(
          e.target.value
        );

        setloading(true)
        axios.post('/api/test_bfile_by_phone', {
          agency_id: data.agency_id || agencyIdRef.current,
          phone: phoneNumberFormatterRemoved
        }).then(res => {
          setloading(false)
          // notification.success({message:res.data.message})
          if (res.data.exist && res.data.success && res.data.existing_bfile) {
            setData({
              ...data,
              ...res.data.existing_bfile,
              phone: F.phone_format(res.data.existing_bfile.phone.trim().replace(/[^0-9]/g, '')),
              dob_mm: res.data.existing_bfile.birthday && res.data.existing_bfile.birthday.split("/")[0] + " - " + monthNames[parseInt(res.data.existing_bfile.birthday.split("/")[0]) - 1] || "",
              dob_yyyy: res.data.existing_bfile.birthday && res.data.existing_bfile.birthday.split("/")[2] || ""

            })
            setWizard({ ...wizard, id: res.data.existing_bfile.id })

            // Modal.confirm({
            //   title: 'Confirmation',
            //   width:500,
            //   content: 'It looks like a profile already exists on this customer. Would you like to view the existing B File?',
            //   okText: 'Yes',
            //   cancelText: 'No',
            //   onOk:()=>{


            //   return null
            //   },
            //   onCancel:()=>{resetSetForm();return null}
            // });


          } else {
            setData({
              ...data,
              phone: e.target.value,
              first_name: "",
              last_name: "",
              dob_mm: "",
              dob_yyyy: "",
              address: "",
              address_cont: "",
              city: "",
              state: "",
              zipcode: ""
            })

            setWizard({ ...wizard, id: "", vob_archived: null })


          }
        })
      }
    }
  };

  const dob_years = [];
  const dob_months = [];


  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  for (let i = 1; i < 13; i++) {
    if (i < 10) {
      dob_months.push({
        name: monthNames[i - 1],
        value: "0" + i + " - " + monthNames[i - 1]
      });
    } else {
      dob_months.push({
        name: monthNames[i - 1],
        value: i + "" + " - " + monthNames[i - 1],
      });
    }
  }
  for (let i = new Date().getFullYear(); i >= 1900; i--) {
    if (i < 10) {
      dob_years.push("0" + i);
    } else {
      dob_years.push(i + "");
    }
  }




  return (
    <div>
      <Modal
        title="Request Call"
        visible={props.showModal}
        destroyOnClose={true}
        // okText='Send Call Request'
        okButtonProps={{ disabled: loading }}
        // onOk={SendFollowUp}
        width={600}
        onCancel={() => {
          setData({
            first_name: "",
            last_name: "",
            phone: "",
            dob_mm: "",
            dob_yyyy: "",
            fs_effective_date: moment(),
            rs_effective_date: moment(),
            type_of_call: 'FollowUp',
            sub_type_of_call: "Thank You / Referrals",
            note: "",
            type_of_call_visible: { vonboard: 0, review: 0, is_lead: 0, is_opportunity: 0 }
          });
          props.hideModal()
        }}
        footer={
          <React.Fragment>
            <Button
              className='borderRadius-28'
              onClick={() => {
                setData({
                  first_name: "",
                  last_name: "",
                  phone: "",
                  dob_mm: "",
                  dob_yyyy: "",
                  fs_effective_date: moment(),
                  rs_effective_date: moment(),
                  type_of_call: 'FollowUp',
                  sub_type_of_call: "Thank You / Referrals",
                  note: "",
                  type_of_call_visible: { vonboard: 0, review: 0, is_lead: 0, is_opportunity: 0 }
                });
                props.hideModal()
              }}>
              <Translate text={`Cancel`} />
            </Button>
            <Button className="btn-bg-164897 borderRadius-28" onClick={() => SendFollowUp()} loading={loading} disabled={loading}>
              <Translate text={`Send Call Request`} />
            </Button>
          </React.Fragment>
        }

      >
        <Spin indicator={antIcon} spinning={loading}>
          <Row gutter={16} style={{ marginBottom: 20 }} >
            {data.type_of_call_visible && data.type_of_call_visible["is_lead"] == 1
              && <Col md={data.type_of_call_visible["is_lead"] ? 6 : 12} span={24}>
                <Button style={{ width: '100%', fontSize: 12 }}
                  className='borderRadius-28'
                  type={data.type_of_call && data.type_of_call.toLowerCase() === 'prospect' ? "primary" : ""}
                  ghost={data.type_of_call && data.type_of_call.toLowerCase() === 'prospect' ? true : false}
                  onClick={() => onChangeData({ target: { name: 'type_of_call', value: 'Prospect' } })}>
                  Lead
                </Button>
              </Col>}
            {data.type_of_call_visible && data.type_of_call_visible["review"] == 1 &&
              <Col md={data.type_of_call_visible["review"] ? 9 : 24} span={24}>
                <Button
                  className='borderRadius-28'
                  style={{ width: '100%', fontSize: 12 }}
                  type={data.type_of_call && data.type_of_call.toLowerCase() === 'review' ? "primary" : ""}
                  ghost={data.type_of_call && data.type_of_call.toLowerCase() === 'review' ? true : false}
                  onClick={() => onChangeData({ target: { name: 'type_of_call', value: 'Review' } })}>
                  Existing Customer Review
                </Button>
              </Col>}
            {data.type_of_call_visible && data.type_of_call_visible["is_opportunity"] == 1
              && <Col md={data.type_of_call_visible["is_opportunity"] ? 9 : 12} span={24}>
                <Button
                  className='borderRadius-28'
                  style={{ width: '100%', fontSize: 12, paddingLeft: '8px' }}
                  type={data.type_of_call && data.type_of_call.split('-').join().toLowerCase() === 'followup' ? "primary" : ""} ghost={data.type_of_call && data.type_of_call.split('-').join().toLowerCase() === 'followup' ? true : false} onClick={() => onChangeData({ target: { name: 'type_of_call', value: 'FollowUp' } })}>
                  Existing Customer Opportunity
                </Button>
              </Col>}
          </Row>


          {data.type_of_call && <div style={{ margin: '20px 0px' }}>
            <label style={{ marginBottom: 20 }}>
              <Translate text={`Sub Type of Call`} />:
              <span className='asteriskIcon'>*</span>
            </label>
            {data.type_of_call && data.type_of_call.split("-").join("").toLowerCase() === 'followup' &&

              <Checkbox.Group value={get_label_from_value(data.sub_type_of_call, 'value', data.type_of_call) && get_label_from_value(data.sub_type_of_call, 'value', data.type_of_call).split(",") || []}

                onChange={(e) => onChangeData({ target: { name: 'sub_type_of_call', value: e } })}
                style={{ display: 'flex', flexWrap: 'wrap' }}
              //  options={SUB_TYPE_OF_CALL[data.type_of_call && data.type_of_call.split("-").join("").toLowerCase() === 'followup' && 'FollowUp'||data.type_of_call||""]}   

              >
                {SUB_TYPE_OF_CALL[data.type_of_call && data.type_of_call.split("-").join("").toLowerCase() === 'followup' && 'FollowUp' || data.type_of_call || ""].map((option, i) => (
                  <Checkbox key={i} value={option.value} style={{ width: 180 }} disabled={option.disable}>
                    {option.label}
                  </Checkbox>))}

              </Checkbox.Group>


            }

            {data.type_of_call && ['prospect', 'review'].includes(data.type_of_call.toLowerCase()) &&

              <Radio.Group style={{ width: '100%' }} value={get_label_from_value(data.sub_type_of_call, 'value', data.type_of_call)} name='sub_type_of_call' onChange={(e) => onChangeData(e)}  >
                <Row gutter={12}>
                  {SUB_TYPE_OF_CALL[data.type_of_call].map((e, i) => {
                    return (
                      <Col md={9} span={24}>
                        <Radio value={e.value}>{e.label}</Radio>
                      </Col>
                    )
                  })}
                </Row>
              </Radio.Group>

            }
          </div>}

          <div style={{ marginBottom: 10 }}>
            <label style={{ marginBottom: 20 }}>
              {
                data.type_of_call === 'Review' ? (
                  <Translate text={`Review Active Month`} />
                ) : (
                  <Translate text={`Follow-Up Active Month`} />
                )
              }
            </label>
            <br />
            {data.type_of_call === 'Review' ? (
              <Select
                value={months[selectedMonth]}
                onChange={(monthName) => {
                  const selectedMonthIndex = months.indexOf(monthName);
                  handleMonthChange(selectedMonthIndex);
                }}
                style={{ width: 200 }}
              >
                {months.map((month, index) => {
                  const isCurrentMonth = index == currentMonth;
                  const isPastMonth = index < currentMonth;
                  const disabledMonth = (isCurrentMonth && currentDate >= 15);
                  //  || (isPastMonth && !isCurrentMonth);
                  return (
                    <Option
                      key={month}
                      value={month}
                      disabled={disabledMonth}
                    // style={{ fontSize: '12px' }}
                    >
                      {month}
                    </Option>
                  )
                })}
              </Select>
            ) : (


              <Select
                value={months[selectedMonth]}
                onChange={(monthName) => {
                  const selectedMonthIndex = months.indexOf(monthName);
                  handleMonthChange(selectedMonthIndex);
                }}
                style={{ width: 200 }}
              >
                {months.map((month, index) => {
                  const isCurrentMonth = index == currentMonth;
                  const isPastMonth = index < currentMonth;
                  const disabledMonth = (isCurrentMonth && currentDate >= 15);
                  return (
                    <Option
                      key={month}
                      value={month}
                      disabled={disabledMonth}
                    // style={{ fontSize: '12px' }}
                    >
                      {month}
                    </Option>
                  )
                })}
              </Select>

              // <DatePicker
              //   format="MM/DD/YYYY"
              //   value={data.fs_effective_date}
              //   disabledDate={current => current && current < moment().startOf("day")}
              //   onChange={(val) =>
              //     onChangeData({
              //       target: {
              //         name: 'fs_effective_date',
              //         value: val ? val : null
              //       }
              //     })
              //   }
              // />


            )}
          </div>

          <Row>


            <Col style={{ marginBottom: 10 }} md={24} span={24}>
              <label>
                <Translate text={"Phone Number"} />
                <span className='asteriskIcon'>*</span>
              </label>
              <Input onChange={(e) => {
                if (e.target.value.trim().length <= 14) {
                  e.target.value = F.phone_format(e.target.value.trim().replace(/[^0-9]/g, ''));
                  onChangeData(e)
                }

              }} name="phone" value={data.phone} placeholder="Phone Number" />
            </Col>

            <Col style={{ marginBottom: 10 }} md={24} span={24}>
              <label>
                <Translate text={"First Name"} />
                <span className='asteriskIcon'>*</span>
              </label>
              <Input
                maxLength={50}
                onChange={(e) => onChangeData(e)} name="first_name" value={data.first_name} placeholder="First Name" />
            </Col>
            <Col style={{ marginBottom: 10 }} md={24} span={24}>
              <label>
                <Translate text={"Last Name"} />
                <span className='asteriskIcon'>*</span>
              </label>
              <Input
                maxLength={50}
                onChange={(e) => onChangeData(e)} name="last_name" value={data.last_name} placeholder="Last Name" />
            </Col>
            {user && user.carrier !== "Country Financial" && <Col style={{ marginBottom: 10 }} md={24} span={24}>
              <label>
                {/* <Translate text={`DOB`} /> * */}
                <Translate text={`DOB`} /> <span className="required-symbol">*</span>
              </label>
              <Row gutter={5}>
                <Col md={10} span={24}>
                  <Select
                    value={data.dob_mm}
                    name="dob_mm"
                    style={{ width: "100%" }}
                    onChange={(e) => onChangeData({ target: { name: "dob_mm", value: e } })}
                    showSearch
                  >
                    <Option value={""}>{"MM"}</Option>
                    {dob_months.map((item, i) => (
                      <Option value={item.value} key={i}>
                        <Translate text={item.value} />
                      </Option>
                    ))}
                  </Select>
                </Col>
                <Col md={4} span={24}>
                  <Select
                    value={data.dob_yyyy}
                    name="dob_yyyy"
                    style={{ width: "100%" }}
                    onChange={(value) => onChangeData({ target: { name: "dob_yyyy", value } })}
                  >
                    <Option value={""}>{"YYYY"}</Option>
                    {dob_years.map((value, i) => (
                      <Option value={value} key={i}>
                        {value}
                      </Option>
                    ))}
                  </Select>
                </Col>
              </Row>
            </Col>}
          </Row>
          <Row gutter={[8, 16]}>
            <Col span={12}>
              <label>
                <Translate text={"Street Address 1"} />
              </label>
              <Input
                onChange={(e) => handleAddressChange(e)}
                name="address"
                value={data.address}
                placeholder="Street 1" />
              {places.length > 0 &&
                renderDropDown(places)
              }
            </Col>
            <Col span={12}>
              <label>
                <Translate text={"Street Address 2"} />
              </label>
              <Input
                onChange={(e) => onChangeData(e)}
                name="address_cont"
                value={data.address_cont}
                placeholder="Street 2" /></Col>
            <Col span={6}>
              <label>
                <Translate text={"City"} />
              </label>
              <Input
                onChange={(e) => onChangeData(e)}
                name="city"
                value={data.city}
                placeholder="City" /></Col>
            <Col span={6}>
              <label>
                <Translate text={"State"} />
              </label>
              <Input
                onChange={(e) => onChangeData(e)}
                name="state"
                value={data.state}
                placeholder="State" /></Col>
            <Col span={6}>
              <label>
                <Translate text={"Zipcode"} />
              </label>
              <Input
                onChange={(e) => onChangeData(e)}
                name="zipcode"
                value={data.zipcode}
                placeholder="Zipcode" /></Col>
            <Col span={6}>
              <label>Country</label>
              <Input
                disabled
                value={"United States"}
              />
            </Col>
          </Row>
          <div>
            <label>
              <span>
                Notes{" "}
                <span style={{ color: "red" }}>
                  (Please give specific details regarding your request.)
                </span>{" "}
                <span className='asteriskIcon'>*</span>
              </span>
            </label>
            <TextArea
              rows={4}
              value={data.note}
              onChange={(e) => onChangeData({ target: { name: 'note', value: e.target.value } })}
            />
          </div>
        </Spin>
      </Modal>
    </div>

  )
})

export default SentFollowupModal;


// WEBPACK FOOTER //
// ./src/scenes/LandingPage/parts/sent-followup-modal.js